import { getMaxmindAccountId } from 'Utils/features';

const ACCOUNT_ID = getMaxmindAccountId();

const initMaxMindTrackDevices = () => {
  const scriptId = `maxmind_${ACCOUNT_ID}`;
  if (document.getElementById(scriptId) === null) {
    /* eslint no-underscore-dangle: ["error", { "allow": ["__mmapiws"] }] */
    window.__mmapiws = window.__mmapiws || {};
    const mmapiws = window.__mmapiws;
    mmapiws.accountId = ACCOUNT_ID;
    const loadDeviceJs = () => {
      const element = document.createElement('script');
      element.async = true;
      element.id = scriptId;
      element.src = 'https://device.maxmind.com/js/device.js';
      document.body.appendChild(element);
    };
    loadDeviceJs();
  }
};

export default initMaxMindTrackDevices;
